import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { LoadingSpinner } from './LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

export function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { currentUser, isAdmin, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <LoadingSpinner />
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className="terminal-card" style={{ textAlign: 'center', maxWidth: '400px' }}>
          <div className="card-header"><span className="card-num">ERR</span> ACCESS DENIED</div>
          <div className="card-body">
            <div style={{ fontSize: '3rem', fontWeight: 700, color: 'var(--danger)', marginBottom: '0.5rem' }}>403</div>
            <p style={{ color: 'var(--muted)', textTransform: 'uppercase', fontSize: '0.875rem' }}>You don't have permission to access this page.</p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}


